import { render, staticRenderFns } from "./DeductionOrderTable.vue?vue&type=template&id=ff78a906&scoped=true"
import script from "./DeductionOrderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeductionOrderTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DeductionOrderTable.vue?vue&type=style&index=0&id=ff78a906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff78a906",
  null
  
)

export default component.exports